import { navigate } from '@reach/router';

export const goToSeasonsSettings = (clubId: string) => () =>
  navigate(`/staff/club/${clubId}/club-settings?section=seasons`);
